<template lang="pug">
#privacy-policy
	div.header
		h1.header-1 Privacy Policy
	include privacy-policy-content.pug

</template>
<script lang="ts" setup>
import {ref, onMounted, computed,Ref } from "vue";

</script>

<style lang="scss">
#privacy-policy{
	width: 100%;
	max-width: 100rem;
	height: calc(100% - 5rem);
	color: white;

	.header{
		padding: 1rem;
		margin: auto;
		background: $color-black;

		h1{
			color: $color-white;
			text-align: center;
		}
	}

	.content {
		max-width: 50rem;
		height: fit-content;
		max-height: calc(100% - 10rem);
		padding: 2rem;
		margin: auto;
		overflow: auto;
		background: $color-white;

		&, p, h2 {
			color: $color-black;
		}

		h2{
			margin-block: 2rem 1rem;
			font-size: 2rem;
		}
	}
}
</style>